import cn from 'classnames';
import React from 'react';

const SIZES = {
    SMALL: 's',
    MEDIUM: 'm',
    LARGE: 'l',
    XLARGE: 'xl',
};

const MaxWidthContainer = (props) => {
    const {className, children, size = SIZES.SMALL} = props;

    return (
        <div
            className={cn(
                'flex flex-col items-center',
                {
                    'max-w-[536px]': size === SIZES.SMALL,
                    'max-w-[724px]': size === SIZES.MEDIUM,
                    'max-w-[1280px]': size === SIZES.LARGE,
                    'max-w-[1488px]': size === SIZES.XLARGE,
                },
                className
            )}
        >
            {children}
        </div>
    );
};

export default MaxWidthContainer;
